import { ar as e } from "./locales/ar.js";
import { de as t } from "./locales/de.js";
import { en as n } from "./locales/en.js";
import { es as r } from "./locales/es.js";
import { fr as i } from "./locales/fr.js";
import { pt as a } from "./locales/pt.js";
import { ru as o } from "./locales/ru.js";
import { zhCn as s } from "./locales/zh-cn.js";
//#region src/schema/localization/translations.ts
var c = {
	en: n,
	de: t,
	es: r,
	fr: i,
	pt: a,
	ru: o,
	ar: e,
	"zh-CN": s
};
//#endregion
export { c as schemaTranslations };

//# sourceMappingURL=translations.js.map